import { assert } from '../app/logger.js';
import { Dialog } from '../controls/dialog.js';

/**
 * Location delete dialog.
 */
class LocDeleteDialog extends Dialog {
  static titleMarkup = `Delete location`;

  static bodyMarkup = `
    <form class='default'>
      <label>
        <span>Are you sure you want to delete
        <span class='designation'></span> location?<br>
        <span class='delete-dialog-caution'>Caution!</span> This operation can't be undone.
        </span>
      </label>
    </form>
  `;

  static buttons = {
    accept: {
      label: 'Delete',
    },
    cancel: {
      label: 'Cancel',
      default: true,
    },
  };

  static get selectors() {
    return Object.assign({}, super.selectors, {
      Designation: '.designation',
    });
  }

  static get elements() {
    return {
      designationElement: this.selectors.Designation,
    };
  }

  set(loc) {
    assert(loc, `['loc:delete-dialog'] no loc`);
    this.#loc = loc;
    this.designationElement.textContent = loc.name;
  }

  get data() {
    return this.#loc;
  }

  static tagName = 'loc-delete-dialog';

  #loc;
}

LocDeleteDialog.defineCustomElement();

export { LocDeleteDialog };
